import ZoomableImage from "./ZoomableImage";
import q from "../styles/components/examQuestion.module.scss";

const QuestionImageGallery = ({ images = [] }) => {
    if (!images.length) return null;

    const isMulti = images.length > 1;

    return (
        <div className={`${q.mediaBlock} ${q.imageGallery}`}>
            {isMulti && (
                <p className={q.mediaSectionLabel}>{`${images.length} تصویر`}</p>
            )}
            <div className={`${q.imageGalleryGrid} ${isMulti ? q.imageGalleryGrid_multi : ""}`}>
                {images.map((image, index) => (
                    <div key={image.id ?? index} className={q.imageGalleryItem}>
                        <ZoomableImage
                            src={image.path}
                            alt={image.original_name || `تصویر سوال ${index + 1}`}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionImageGallery;
